import COLORS from '../../../utils/constants/colors'

const signUpFormStyles = (theme) => ({
  formWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 15,
  },
  termWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    textAlign: 'left',
    fontSize: 13,
    lineHeight: 1.4,
  },
  checkboxCell: {
    flex: '0 0 auto',
    marginTop: 2,
  },
  termText: {
    flex: '1 1 auto',
  },
  link: {
    color: COLORS.purple,
  },
  lockedEmailNote: {
    width: '100%',
    marginTop: -10,
    fontSize: 12,
    textAlign: 'left',
  },
  errorMessage: {
    fontSize: 12,
    color: theme.palette.error.main,
    marginTop: 3,
    marginLeft: 14,
    marginRight: 14,
    textAlign: 'start',
  },
})

export default signUpFormStyles;
